import {React, Link} from 'external/react'
import {styled, IconButton, ArrowBackIosIcon} from 'external/material'

const StyledBackButton = styled(IconButton)(backButtonStyles)

export default function BackButton({link = '#', onClick}) {
  return (
    <StyledBackButton component={Link} to={link} onClick={onClick}>
      <ArrowBackIosIcon className="icon" />
    </StyledBackButton>
  )
}

function backButtonStyles({theme}) {
  return {
      borderRadius: 0,
      backgroundColor: '#fff',
      marginRight: theme.spacing(2),
      borderRight: 'solid 1px #dbe3e6',
      '&:hover': {
        backgroundColor: '#ccc',
        '& .icon': {
          transform: 'scale(1.1)',
          fill: '#000',
        }
      },
      "& .icon": {
        margin: '0 0 0 6px',
        fill: '#4f556d',
      }
    }
}
